import { Loader } from '@crehana/compass.ui/loader';

const Loading = () => {
  return (
    <div className="tw-relative tw-h-full tw-w-full tw-pointer-events-none tw-flex tw-items-center tw-justify-center">
      <Loader />
    </div>
  );
};

export default Loading;
